export const AmeyoConstants = {
  MUTE_ONGOING_CALL_TOOLTIP: 'Mute (Ctrl+M)',
  UNMUTE_ONGOING_CALL_TOOLTIP: 'Unmute (Ctrl+M)',
  DISCONNECT_ONGOING_AMEYO_CALL: 'Disconnect',
  ONGOING_MUTED_CALL_DICLAIMER: 'You’re on mute, please unmute to talk',
  AMEYO_EXTENSION_DISABLED_MSG: 'All actions disabled. Please turn on the extension.',
  AMEYO_ERRONEOUS_MSG: 'Something went wrong. Please report to your TL.',
  AMEYO_WIDGET: 'AMEYO_WIDGET',
  AMEYO_TOOLBAR: 'AMEYO_TOOLBAR',
  AMEYO_SHORTCUT: 'AMEYO_SHORTCUT'
};

export const AMEYO_MUTE_DISCLAIMER_INTERVAL = 5000;

export const AmeyoToggleNewStatus = {
  OFF: 'OFF',
  ON: 'ON'
};

export enum PING_PONG_CLICKSTREAM_EVENT_SOURCE {
  LONGHORN = 'LONGHORN',
  AMEYO = 'AMEYO'
}

export enum AmeyoCallState {
  IDLE = 'IDLE',
  RINGING = 'RINGING',
  TALKING = 'TALKING'
}

export const AMEYO_CALL_STATUS_POLLING_INTERVAL = 2000;
export const AMEYO_CALL_COUNT_POLLING_INTERVAL = 60000; // 1 minute

export enum AMEYO_DOWNTIME_STATUS {
  DOWN = 'DOWN',
  UP = 'UP',
  LESS_CALLS = 'LESS_CALLS',
  NOT_AVAILABLE = 'NOT_AVAILABLE'
}
